export default __webpack_public_path__ + "static/media/GAIL.4f146018.png";